<template>
  <v-step
    :step="step"
    :previous-step="tour.previousStep"
    :next-step="tour.nextStep"
    :stop="tour.stop"
    :is-first="tour.isFirst"
    :is-last="tour.isLast"
    :labels="tour.labels"
  >
    <div slot="header">
      <div v-if="step.header" class="v-step__header">
        <div v-html="$t(step.header.title)"></div>
      </div>
    </div>
    <div slot="content">
      <div class="v-step__content">
        <div v-html="$t(step.content)"></div>
      </div>
    </div>
    <div slot="actions" class="flex justify-center">
        <vs-button
            size="small"
            class="mr-3"
            @click="tour.stop"
            icon-pack="feather"
            icon="icon-x"
            icon-after
            color="#fff"
            type="border"
            v-if="tour.currentStep != tour.steps.length - 1">
            {{ $t('Skip') }}
        </vs-button>

        <vs-button
            size="small"
            @click="tour.previousStep"
            icon-pack="feather"
            icon="icon-chevrons-left"
            color="#fff"
            type="border"
            class="mr-3"
            v-if="tour.currentStep">
            {{ $t('Previous') }}
        </vs-button>

        <vs-button
            size="small"
            @click="tour.nextStep"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            color="#fff"
            type="border"
            class="btn-tour-next"
            v-if="tour.currentStep != tour.steps.length - 1">
            {{ $t('Next') }}
        </vs-button>

        <vs-button
            size="small"
            @click="tour.stop"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-after
            color="#fff"
            type="border"
            class="btn-tour-finish"
            v-if="tour.currentStep == tour.steps.length - 1">
            {{ $t('Finish') }}
        </vs-button>
    </div>
  </v-step>
</template>

<script>


export default {
  name: 'vx-tour-step',
  props: {
    tour: { required: true },
    step: { required: true }
  },
  computed: {
    skipThis() {
      return this.$store.state.tour.skip_steps.includes(this.tour.currentStep)
    }
  },
  watch: {
    skipThis(okay) {
      if(okay)
        this.skip();
    }
  },
  mounted() {
    if(this.skipThis)
      this.skip();
  },
  methods: {
    skip() {
        console.log('skipping step no.', this.tour.currentStep)
        console.log('skipping step no.', this.$store.state.tour.action_type)
        switch (this.$store.state.tour.action_type) {
          case 'next':
            this.tour.nextStep();
            break;
          case 'previous':
            this.tour.previousStep();
            break;
          default:
            break;
        }
    }
  }
}
</script>

<style>

</style>